import { createGlobalStyle } from 'styled-components';
import { printId, spacing } from 'commons';

export const GlobalStyles: any = createGlobalStyle`
  * {
    padding: 0;
    border: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;

    
    @media print {
      font-family: Arial, Helvetica, sans-serif;
    }

    ::-webkit-scrollbar {
      width: ${spacing.scrollbarSize};
      height: ${spacing.scrollbarSize};
      border-radius: ${spacing.scrollbarSize};
      background-color: ${({ theme }) => theme.neutral_300};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.neutral_500};
      border-radius: ${spacing.scrollbarSize};

      &:hover {
        background-color: ${({ theme }) => theme.neutral_700};
      }

      &:active {
        background-color: ${({ theme }) => theme.neutral_900};
      }
    }
  }

  body {
    font-size: 16px;
    font-style: normal;

    @media screen {
      #${printId}, #${printId} *{
        display: none;
      }
    }

    @media print {
      *:not(#${printId}, #${printId} *) {
        display: none;
        visibility: hidden;
      }

      #${printId}, #${printId} *{
        visibility: visible;
      }
    }
  }

  input, select:focus, textarea {
    font-size: 16px;
  }
  
  .grecaptcha-badge {
    visibility: hidden;
  }
`;
